import { ConvertPriceToString, CapitalizeFirstLowercaseRest } from '../../../../Helpers/CustomConverter'
import { useParams } from '../../../../Providers/ParamsProvider'
import useGetProductImage from '../../../../Hooks/useGetProductImage'
import { useCart } from '../../../../Providers/CartProvider'

import '../../../../Components/BasketPage/Styles/BasketPageStyles.css'

const ProductInOrderSummary = ({ photoFileName, title, label, baseUnit, qty, priceNet, currency, priceGross, taxRate }) => {
    const { GetProductImage } = useGetProductImage()
    const { isMobile } = useParams()
    const { getGrossValue } = useCart()

    if (isMobile) {
        return (<div className="container-fluid">
            <div className="row">
                <div className="col-4">
                    <div className='cart-product-img'>
                        <GetProductImage
                            photoFileName={photoFileName}
                        />
                    </div>
                </div>
                <div className="col-8 d-flex flex-column">
                    <p>{CapitalizeFirstLowercaseRest(title)}</p>
                    <p className='light-text-color'>{label}</p>
                </div>
            </div>
            <div className="row mt-3 mb-4 product-in-order">
                <div className="col-4">
                    <span className="text-secondary me-2">Ilość:</span>
                    <span>{qty} {baseUnit}</span>
                </div>
                <div className="col-8">
                    <b style={{ fontSize: '18px' }}>{ConvertPriceToString((priceNet * qty), currency)}</b>
                    <div className='d-flex'>
                        <p>{ConvertPriceToString(getGrossValue(priceNet, qty, taxRate), currency)}</p>
                        <p className="text-secondary ms-3">{taxRate}%</p>
                    </div>
                </div>
            </div>
        </div>)
    }
    else {
        return (
            <div className="container-fluid">
                <div className="row product-in-order mt-3">
                    <div className="col-2">
                        <div className='cart-product-img'>
                            <GetProductImage
                                photoFileName={photoFileName}
                            />
                        </div>
                    </div>
                    <div className="col-7">
                        <div className="d-flex flex-column">
                            <p>{CapitalizeFirstLowercaseRest(title)}</p>
                            <p className='light-text-color'>{label}</p>
                            <div className="d-flex align-items-center">
                                <span className="text-secondary me-2">Ilość:</span>
                                <span>{qty} {baseUnit}</span>
                            </div>
                        </div>
                    </div>
                    <div className="col">
                        <div className="d-flex flex-column">
                            <b>{ConvertPriceToString((priceNet * qty), currency)}</b>
                            <div className='d-flex align-items-center'>
                                <p>{ConvertPriceToString(getGrossValue(priceNet, qty, taxRate), currency)}</p>
                                <p className="text-secondary ms-3">{taxRate}%</p>
                            </div>
                        </div>
                    </div>
                    <div className="row mb-3"></div>
                </div>
            </div>
        )
    }

}

export default ProductInOrderSummary